import React, {useState, useEffect} from 'react';
import { Row, Col, Card, CardBody,CardTitle, CardHeader, Table} from 'reactstrap';
import Swal from 'sweetalert2'
import axios from 'axios';
import { data_type_id } from '../../config';
import { changeIntoDateTime } from '../../utlis';
import { checkData } from '../../ObjectExist';
const MyDownloads = (props) => {  
  const [myDownload, setMyDownload] = useState({})
  const [loader, setLoader] = useState(false)
  useEffect(() => {
    setLoader(true);
    myDownloadListing()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const myDownloadListing = () => {
    axios.post(process.env.REACT_APP_ADMINDOWNLOAD_LIST,{"admin_id" : props.user[0].id})
    .then((res) => {
      setLoader(false);
      if(res.data !== undefined && res.data.fatal !== true){
        if(parseInt(res.data.errno)>0){
          if(res.data.sqlMessage!==undefined){
            Swal.fire({icon:'error',text:res.data.sqlMessage,title:'Error in SQL'});
          }
        }else{
          if(res.fatal !== true && res.error !== true){
            setMyDownload(res.data);
          }
          else{
            Swal.fire({title: 'Error',text: res.msg,icon: 'error',})
          }
        }
      }
    }).catch((err) => {
      Swal.fire({icon:'error',text:err,title:'Error'});
      setLoader(false);
    });
  }


  return (
    <div className="content-body content overflow-hidden">
      <Row>
       <Col sm={12}>
        <Card className="p-0 my-3 master-content content-wrapper border-0">
            <CardHeader className="page-header d-flex justify-content-between flex-wrap">
              <CardTitle className="mb-0 page-title pb-2 font-weight-bold border-short">My Downloads</CardTitle>              
            </CardHeader>
            <CardBody className="p-0">
              <Table responsive borderless className="text-center customTable">
                <thead>
                  <tr>
                    <th>Sno.</th>
                    <th>Data Type</th>
                    <th>description</th>
                    <th>Download On</th>
                    <th>User</th>
                    <th>Filter</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                {checkData(myDownload.data) ? myDownload.data.map((item, index) => (
                  <tr>
                    <td>{index+1}</td>
                    <td>{data_type_id[item.data_type_id]}</td>
                    <td>{item.description}</td>
                    <td>{changeIntoDateTime(item.created_at)}</td>
                    <td>{item.UserName}</td>
                    <td>{item.filter}</td>
                    <td><a href={process.env.REACT_APP_BASE_URL+item.file_name} download target ="_blank" rel="noreferrer">Download</a></td>
                  </tr>
                  ))
                  :loader ?<td colSpan="7">Loading...</td>: <td colSpan="6" className="text-center">No Data Found</td>}
                </tbody>
              </Table>
            </CardBody>
        </Card>
      </Col>
      
      </Row>
       </div>
  );
}

export default MyDownloads;